import * as React from "react";
const SvgFiRrFonduePot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fondue-pot_svg__a)">
      <path
        fill="#062147"
        d="M23 8h-3.866l3.228-5.493a1 1 0 0 0-1.724-1.014L16.815 8h-2.653l1.804-6.742a1 1 0 1 0-1.932-.516L12.092 8H7.185L3.362 1.494a1 1 0 0 0-1.725 1.013l3.228 5.494H1a1 1 0 0 0 0 2h1v1c0 3.462 1.77 6.517 4.451 8.313A4.01 4.01 0 0 0 4 23.001a1 1 0 1 0 2 0c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2a1 1 0 1 0 2 0 4 4 0 0 0-2.451-3.687C20.23 17.518 22 14.463 22 11.001v-1h1a1 1 0 1 0 0-2zm-3 3c0 4.411-3.589 8-8 8s-8-3.589-8-8v-1h16z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fondue-pot_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFonduePot;
